import type { ReactNode } from 'react';
import React from 'react';
import Link from 'next/link';

import { HeaderLogoSVG } from '@ui';

interface HeaderLogoProps {
  locale?: 'en' | 'es';
  href?: string;
  /** Visible site / product name (e.g. global `site_name` in locale JSON). */
  siteNameLabel?: string;
  /** Fallback for logo text when `siteNameLabel` is omitted (e.g. `site_owner`). */
  siteOwnerLabel?: string;
  /** When set, rendered inside `.logo-icon` instead of the default `HeaderLogoSVG`. */
  logoSvg?: ReactNode;
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({
  locale = 'en',
  href,
  siteNameLabel,
  siteOwnerLabel,
  logoSvg,
}) => {
  const resolvedHref = href ?? '/';
  const label = siteNameLabel ?? siteOwnerLabel ?? 'Tulio Solorzano';

  return (
    <Link
      href={resolvedHref}
      title={label}
      className='logo-block'
    >
      <div className='logo-icon'>{logoSvg ?? <HeaderLogoSVG logoClass='header-logo' />}</div>
      <div className='logo-text'>{label}</div>
    </Link>
  );
};

export type { HeaderLogoProps };
export default HeaderLogo;
